export { TreeSelectDefaultOptions } from './models/tree-select-default-options';
export { TreeSelectComponent } from './components/tree-select.component';
export { ItemPipe } from './pipes/item.pipe';
export { NgxTreeSelectModule } from './module';
export { ExpandMode } from './models/expand-mode';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/ngx-tree-select/src/index.js
// module id = 170
// module chunks = 0